module.exports = __webpack_public_path__ + "static/Randy-Stickles-talking-to-students-d26b3b28ebce71c1769959c1d190cc4a.jpg";